// src/components/AnalyticsTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GOOGLE_ID = 'G-5MDVT8Q0FS';    // ✅ 본인의 GA ID로 교체
const NAVER_ID = '1a39b9042a02cf0'; // ✅ 본인의 네이버 wa 값으로 교체


const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // 🔹 Google Analytics: 페이지뷰 전송
    if (window.gtag) {
      window.gtag('config', GOOGLE_ID, {
        page_path: location.pathname + location.search,
      });
    }

    // 🔹 Naver Analytics: SPA 추적 처리
    if (window.wcs) {
      window.wcs_do();
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
